<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Movement Type</h1>
        <v-row v-if="this.user.username == '128TCI'">
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="mt.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="mt.description"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
            <v-checkbox
              label="With Duration"
              :class="classPadding"
              v-model="mt.withDuration"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
            <v-checkbox
              label="InActive Employee"
              :class="classPadding"
              v-model="mt.inActiveEmp"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="this.user.username == '128TCI'">
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
        </template>
      </list>
      <router-view />
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import List from "./List";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/movementType";
export default {
  metaInfo: {
    title: "Movement Type",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    mt: {},
    componentKey: 0
  }),
  methods: {
    ...mapActions("movementType", ["selectMovementType"]),
    ...mapActions("users", ["getCurrentUser"]),
    save() {
      this.isSaving = true;

      this.$axios
        .post(`${API_ENDPOINT}`, this.mt)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      this.selectMovementType(item);
      this.$router.push(`/movement-type/edit/${item.code}`);
    },
    reset() {
      this.mt = {};
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    }
  },
  computed: {
    ...mapState("users", {
      user: state => state.user
    })
  },
  watch: {
    $route(val) {
      if (val.name === "movement-type") {
        this.forceRerender();
      }
    }
  },
  created() {
    this.getCurrentUser();

    this.getUserAccessRights("MovType");
  }
};
</script>